import { useCallback } from 'react';

import { useTrackPausedVideo } from '@air/analytics';

import { usePlayerStore } from '../components/PlayerContextProvider';

export const usePlayerPause = () => {
  const id = usePlayerStore((state) => state.id);
  const videoElement = usePlayerStore((state) => state.videoElement);
  const { trackPausedVideo } = useTrackPausedVideo();

  const onPlayerPause = useCallback(() => {
    if (videoElement) {
      videoElement.pause();
      trackPausedVideo({ id });
    }
  }, [videoElement, id, trackPausedVideo]);

  return { onPlayerPause };
};
